import { Box, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { isNonEmptyString } from '../helpers/StringUtils';
import { CopyReferralLinkButton } from './CopyReferralLinkButton';
import { ReferralOnePagerButton } from './ReferralOnePagerButton';

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: 40 },
  topBar: { paddingBottom: 20 },
  title: { paddingBottom: 20 },
  referralButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 10,
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'center',
      flexDirection: 'row',
      paddingTop: 10,
    },
  },
}));

type Props = {
  title: string;
  subtitle?: string;
  description?: string;
  showReferralButton?: boolean;
};

export const TopBar: FunctionComponent<Props> = (props) => {
  const { title, subtitle, description, showReferralButton } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root} data-testid="top-bar">
      <Grid container item xs={12} className={classes.topBar}>
        <Grid item xs={12} sm={6} md={7} lg={6} xl={8}>
          <Box display="flex" alignItems="baseline">
            <Typography variant="h4" className={classes.title}>
              {title}
            </Typography>{' '}
            {isNonEmptyString(subtitle) && (
              <Box paddingLeft={1}>
                <Typography color="primary" variant="h6">
                  {subtitle}
                </Typography>
              </Box>
            )}
          </Box>
          {isNonEmptyString(description) && (
            <Typography display="block" variant="subtitle1">
              {description}
            </Typography>
          )}
        </Grid>

        {showReferralButton && (
          <Grid item xs={12} sm={6} md={5} lg={6} xl={4} className={classes.referralButtons}>
            <CopyReferralLinkButton />
            <ReferralOnePagerButton />
          </Grid>
        )}
      </Grid>
      <Divider />
    </Box>
  );
};
